import { BboxStrategy, Strategy } from "./internal";
/**
 * Holds an array of BoxStrategy-Objects. Registers or removes layers on/from a BoxStrategy-Object.
 *
 * @class MultiBboxStrategy
 * @extends Strategy
 * @author Joel Burkhard
 */
export class MultiBboxStrategy extends Strategy {
    constructor(scene) {
        super(scene);
        this._bboxstrategies = [];
        this._boxdimension_default = 100;
        this._bordertolerance_default = 20;
    }
    /**
     * registers the layer on a boxstrategy-object according to its strategyoptions (boxdimension and bordertolerance
     * @param layer
     */
    register(layer) {
        this._getbylayer(layer).register(layer);
    }
    /**
     * removes the layer from a boxstrategy-object according to its strategyoptions (boxdimension and bordertolerance)
     * @param layer
     */
    remove(layer) {
        this._getbylayer(layer).remove(layer);
    }
    /**
     * returns a bboxstrategy object according to a layers strategyoptions (boxdimension and bordertolerance)
     * @param {Layer} layer
     * @returns {BboxStrategy}
     * @private
     */
    _getbylayer(layer) {
        const bboxoptions = layer.strategyoptions || {};
        const boxdimension = bboxoptions.boxdimension || this._boxdimension_default;
        const bordertolerance = bboxoptions.bordertolerance || this._bordertolerance_default;
        for (const key in this._bboxstrategies) {
            const bboxstrategy = this._bboxstrategies[key];
            if (bboxstrategy.boxdimension == boxdimension && bboxstrategy.bordertolerance == bordertolerance) {
                return bboxstrategy;
            }
        }
        const new_bboxstrategy = new BboxStrategy(this.scene, boxdimension, bordertolerance);
        this._bboxstrategies.push(new_bboxstrategy);
        return new_bboxstrategy;
    }
}
//# sourceMappingURL=multibboxstrategy.js.map